module.exports = {
  language: 'english',
  nav: {
    Home: 'HOME',
    Attackwarn: 'WARNING',
    Product: 'PRODUCT',
    DomainNames: 'DOMAIN',
    Certmanage: 'CERTS',
    HandleLog: 'OPLOG',
    LoginLog: 'LOGINLOG',
    googleCheck: 'GOOGLECODE',
    tip1: 'Please enter the old password',
    tip2: 'Please enter a new password',
    tip3: 'The new password does not match the confirmation password'
  },
  footer: {
    bqDesc: 'The copyright of the reprinted content belongs to the author and the source website. Please indicate the source of the original content reprinted. Please contact the commercial media and paper media first',
    smAddr: 'Legal statement Zhejiang ICP preparation',
    secondDesc: 'The copyright of the reprinted content belongs to the author and the source website. Please indicate the source of the original content reprinted. Please contact the commercial media and paper media first',
    beiAn: 'Legal statement zicp no.09109183-25 zhegongwanganbei no.33010002000124',
  },

  AttackWarn: {
    Attackwarn: 'AttackWarning',
    domain: 'Domain',
    attackCount: 'AttackCount',
    originIp: 'Origin Ip',
    remark: 'Remark',
    date: 'Date',
    type: 'Type',
  },
  product: {
    myProduct: 'My-Product',
    ProductName: 'ProductName',
    createDate: 'CreateDate',
    addedDomain: 'Added/Maxnum',
    setMeal: 'Package',
    handle: 'Operation',
    flow: 'Flow',
    statuscode: 'Statuscode',
    hitrate: 'Hit Rate',
    defense: 'Defense',
    productlist: 'Productlist',
    Statistics: 'Statistics',
    cache: 'Cache',
    strategy: 'Strategy',
    cacheType: 'CacheType',
    cacheTip: 'Multiple file types are separated by a vertical bar "|"',
    cacheDate: 'CacheDate',
    cacheDateTip: 'Unit second, up to 2592000 (30 days), fill in 0 to not cache',
    forceCache: 'ForceCache',
    forceCacheTip: 'Force cache',
    commit: 'Commit',
    allRefresh: 'AllRefresh',

    shield: 'Shield',
    Intercept: 'Intercept',
    onlyWarning: 'OnlyWarning',
    InterceptOnly: 'InterceptOnly',
    BlackList: 'IP pull into blacklist',
    MatchType: 'MatchType',
    matchTip: 'Fuzzy matching and precise matching coexist',
    FuzzyMatch: 'FuzzyMatch',
    PreciseMatch: 'PreciseMatch',
    inputTip: 'Multiple split with newline',
    delete: 'Delete',
    childDomain: 'SubDomain',
    mark: 'Mark'
  },
  allDomain: {
    DomainNames: 'DomainNames',
    domain: 'Domain',
    createDate: 'CreateDate',
    mainDomain: 'Domain',
    group: 'Group',
    products: 'Products',
    status: 'Status',
    cert: 'Cert',
    originSettings: 'OriginSettings',
    originReplace: 'OriginReplace',
    applyCert: 'ApplyCert',
    forceJump: 'ForceJump',
    DefenseStrategy: 'DefenseStrategy',
    cleanCache: 'CleanCache',
    sourceDetect: 'SourceDetect',
    cachefollow: 'Cachefollow',
    stop: 'Stop',
    start: 'Start',
    delete: 'Delete',
    addsubdomain: 'Add Sub Domain',
    config: 'Config',
    redirect: 'Redirect',
    originBroadband: 'OriginBroadband',
    second: 'Second',
    longLink: 'LongLink',
    linkTip: 'The value must be between 10 and 600, and the default value is 600 seconds',
    add: 'Add',
    linkMode: 'LinkMode',
    redictLink: 'RedictLink',
    rootDomain: 'RootDomain',
    ShieldEmptyUA: 'ShieldEmptyUA',
    checkedAll: 'CheckedAll',
    IPWhiteList: 'IPWhiteList',
    whitelistMask: 'whitelistMask',
    URLWhiteList: 'URLWhiteList',
    IPBlackList: 'IPBlackList',
    blackListMark: 'blackListMark',
    URLBlackList: 'URLBlackList',
    ShieldingArea: 'ShieldingArea',
    JsguardDefense: 'JSGuardDefense',
    CaptchaDefense: 'CaptchaDefense',
    TriggerDefenseFrequency: 'TriggerDefenseFrequency',
    commonFrequency: 'CommonFrequency',
    BaseStationFrequency: 'BaseStationFrequency',
    passwordAuth: 'PasswordAuth',
    confirm: 'Confirm',
    cancel: 'Cancel',
    cleanTip: 'Are you sure to clean up the cache for the selected domain name?',
    SetDefense: 'Batch set defense',
    ShieldingUA: 'ShieldingUA',
    JSShield: 'JSShield',
    VerificationCode: 'VerificationCode',
    BatchforceJump: 'BatchforceJump',
    applyTip1: '@The problem of applying together with * will result in a TXT error. Please apply for another after applying for one',
    applyTip2: '@And * resolve to the same, please change the_ The domain name points to the alias domain name obtain-ssl.com',
    originOper: 'originOper',
    originSite: 'OriginSite',
    originSiteAdd: 'originSiteAdd',
    childDomain: 'SubDomain',
    originAddress: 'originAddress',
    InternetProtocol: 'InternetProtocol',
    addRootDomain: 'Add Domain',
    URLRule: 'URLRule',
    visitLog: 'VisitLog',
    visitDate: 'Time',
    originAddr: 'Host',
    status: 'Status',
    method: 'Method',
    InternetAddr: 'URL',
    origin: 'Referer',
    maintain: 'Maintain',
    statusCode: 'Status',
    maintainPage: 'MaintainPage',
    upstreamTip: 'You can fill in multiple subdomains and origin sites (one per line, up to 100), port (1~65535), and lowercase [s] after the port indicates that the origin site is https',
    submitCerts: 'SubmitCerts',
    subdomainTip: 'The subdomain can be empty',
    subdomainTip2: 'The directory can be empty',
    
    timeGranularity: 'time Granularity',
    timeFrame: 'time Frame',
    query: 'query',
    minute: 'minute',
    hour: 'hour',
    day: 'day',
    last7days: 'last 7 days',
    last30days: 'last 30 days',
    flowtip1: 'Please select time granularity',
    flowtip2: 'Please select time frame',
    
    second: 'second',
    DefenseTimes: 'Defense Times(second)',
    RequestRitRatio: 'Request Rit Ratio(%)',
    TrafficHitRate: 'Traffic Hit Rate(%)',
    sourceflow: 'sourceflow(MB)',
    
    Asia: 'Asia',
    Europe: 'Europe',
    SouthAmeria: 'SouthAmeria',
    NorthAmeria: 'NorthAmeria',
    Africa: 'Africa',
    Oceania: 'Oceania',
    tip11: 'Is it maintained',
    tip22: 'Cannot fill in 302',
    tip33: 'The whole HTML page, please set the encoding format for the page, otherwise it may appear garbled!',
    close: 'close',
    
    applyMethod: 'Application method',
    certContent: 'Certificate content',
    tip44: 'Only PEM format is supported',
    tip55: 'Private key content',
    tip66: 'Application type',
    tip77: 'DNS automatic certificate issuing',
    
    tip88: 'please select products',
    tip99: 'Please fill in the domain name',
    tip1: 'You can fill in multiple source IP / domain names (one in a row, up to 10), ports (1-65535), and small s after the port to indicate that the source is HTTPS',
    tip2: 'You can fill in multiple primary domain names and distinguish them in English',
    tip3: 'Replaced source',
    tip4: 'replace with',
    tip5: 'Please input a password',
    tip6:'Please enter the primary domain name',
    tip7: 'Please enter subdomain name',
    tip8: 'Please select at least one domain name!',
    tip9: 'Invalid input',
    tip10: 'Replaced source cannot have port',
    tip111: 'JS defense',
    tip112: 'Captcha defense',
    tip113: 'Set successfully',
    tip114: 'Upload succeeded',
    tip115: 'Successful application',
    tip116: 'Please enter the content of the certificate',
    tip117: 'Please enter the certificate key'
  },
  certManage: {
    certManage: 'CertManage',
    cert: 'Cert',
    certStatus: 'CertStatus',
    type: 'Type',
    autoRenew: 'AutoRenew',
    forceDel: 'ForceDel',
    certSource: 'CertSource',
    dueDate: 'DueDate',
    tip: 'Tip',
    tipDes: 'HTTP certificate application, are you sure to submit the selected domain name?',
    commit: 'Commit',
    all: 'ALL',
    Expire: 'Expire',
    due: 'due',
    normal: 'normal',
    applying: 'applying',
    applyingovertime: 'applying overtime',
    ManualUpload: 'Manual Upload',
    httpApply: 'http Applying',
    dnsApply: 'dns Applying',
    No: 'NO',
    Yes: 'YES',
    delete: 'delete',
    tip1: 'cert，Do you want to continue?',
  },
  handleLog: {
    logList: 'LogList',
    name: 'Name',
    desc: 'Desc',
    modify: 'Modify',
    operDate: 'OperDate',
  },
  LoginLog: {
    loginDate: 'LoginDate',
  },
  Login: {
    username: 'Username',
    placeholdName: 'Please enter your user ID',
    pwd: 'Password',
    placeholdPwd: 'Please enter your password',
    googleCheckcode: 'Google code',
    checkDesc: 'Please enter your Google verification code',
    checkTip: 'No input is required for Google code when the account is not opened.',
    login: 'Login',
    slideText: 'Drag the slider',
    valided: 'Successful',
  },
  Home: {
    accessDomain: 'Access Domain',
    attackedDomain: 'Attacked Domain',
    ProductQuantity: 'Product quantity',
    MaximumTrafficDomain: 'Maximum Traffic Domain',
    table1: 'Top 10 domain names',
    table1Desc: 'The time granularity is 5 minutes, and the flow is accumulated within 5 minutes',
    sysMsg: 'System message',
    newMsg: 'Have news',
    seletDate: 'select date',
    createDate: 'create date',
    bindGoogle: 'bind google auth',
    outnetll: 'Outbound traffic: unit M',
    outnetl: 'Outbound traffic',
    Cachehitrate: ' Cache hit rate',
    Requesthitrate: 'Request hit rate',
    Traffichitrate: 'Traffic hit rate',
    Domain: 'Domain',
    Attacks: 'Attacks',
    Connections: 'Connections'
  },
  common: {
    filter: 'Filter',
    domain: 'Domain',
    search: 'Search',
    reset: 'Reset',
    noContent: 'NO CONTENT',
    refresh: 'Refresh',
    BatchOper: 'BatchOper',
    loginout: 'Loginout',
    updatePwd: 'UpdatePwd',
    pleaseSelect: 'Please Select',
    success: 'Success',
  },
  updatePwd: {
    userName: 'email/userName',
    oldPwd: 'oldPwd',
    newLoginPwd: 'newLoginPwd',
    confirmPwd: 'confirmPwd',
  },
  settings: {
    cache: 'Cache',
    cacheType: 'Cache Type',
    cacheTypeTip: 'html|js|css|jpg …multiple file types are separated by vertical bars "|"',
    cacheTime: 'Cache Time',
    cacheTimeout: 'Cache Timeout',
    cacheTimeoutTip: 'Seconds',
    cacheLimit: 'Return to source bandwidth',
    cacheLimitTip: 'Unit MB',
    cacheLimitTTL: 'TTL',
    cacheLimitTTLTip: 'Second',
    closeCache: 'Force all caches to be closed',
    closeCacheTip: 'Forcibly close all caches, including smart caches, for all systems with special requirements for APIs to prevent caches from affecting the system.',
    useRespMaxAge: 'Cache time follows source',
    useRespMaxAgeTip: 'If the source station sets the cache time of the corresponding suffix, then cdn will follow the source setting for the suffix cache time',
    strategy: 'Strategy',
    keepaliveTime: 'Long connection',
    keepaliveTimeTip: 'The value must be between 10-600, only used for HTTP, WEBSOCKET non-HTTP protocol timeout time has been set to 600 seconds by default',
    ssltype1: '@Certificate',
    ssltype2: '*Certificate',
    ssl_type0: '@ Certificate',
    ssl_type1: '* Certificate（Level 1）',
    ssl_type2: '*.* Certificate（Level 2）',
    ssl_type3: '*.*.* Certificate（Level 3）',
    ssl_type4: 'www Certificate',
    ssl_type5: 'm Certificate',
  },
  
  googleCode: {
    googlecode: 'GoogleCode',
    step1: 'Step One',
    step2: 'Step Two',
    step3: 'Step Three',
    SecretKeyOperation: 'Secret Key Operation',
    secretKeyContent: 'Generate the key by generating the key button',
    bindOper: 'Binding operation',
    bindContent: 'Bind devices through 6-digit digits on Google Validator',
    tip: 'Tips',
    tipContent: 'This account has a token bound. Contact your administrator for additional help',
    createKey: 'Generate Secret Key',
    tip6: '6-digit number on Google Validator',
    tip7: 'Create secret value returned by key interface',
    bind: 'binding',
    lastTip: 'Congratulations, you have successfully bound the token!',
    tip1: 'please input code',
    tip2:'please create secret value',
   }

};

